import { render } from "./FormList.vue?vue&type=template&id=2b1a531b&ts=true"
import script from "./FormList.vue?vue&type=script&lang=ts"
export * from "./FormList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__